import {createLazyFileRoute} from '@tanstack/react-router'

import FoodGrubhubCategoryDetail from '@/views/FoodGrubhubRestaurantDetail/components/CategoryDetail/FoodGrubhubCategoryDetail'

export const Route = createLazyFileRoute(
  '/_food-grubhub/restaurant/$restaurantId/category/$categoryId/',
)({
  component: FoodGrubhubCategoryDetail,
})
